export const getFirstName = (name: string | null) => {
  return name?.split(" ")[0] || "";
};

export const getLastName = (name: string | null) => {
  if (!name) return "";
  const parts = name.split(" ");
  return parts.length > 1 ? parts.slice(1).join(" ") : "";
};

/**
 * 
 * @param name - Full name of the broker
 * @returns Object with firstName and lastName
 * 
 * @example
 * getBrokerNameParts("Anna Maria Svensson") // { firstName: "Anna", lastName: "Maria Svensson" }
 * getBrokerNameParts("Anna") // { firstName: "Anna", lastName: "" }
 * getBrokerNameParts("Anna Maria Christina Elisabeth Svensson") // { firstName: "Anna", lastName: "Maria Christina Elisabeth Svensson" }
 */
export const getBrokerNameParts = (name: string | null): { firstName: string; lastName: string } => {
  if (!name) return { firstName: "", lastName: "" };
  
  const parts = name.trim().split(/\s+/);
  
  // Single name
  if (parts.length === 1) {
    return { firstName: parts[0], lastName: "" };
  }
  
  // Always use first word as first name, rest as last name (including middle names)
  return {
    firstName: parts[0],
    lastName: parts.slice(1).join(" ")
  };
};